import React from 'react';
import StyledBox from 'views/rebranded-module/common/components/UI/ExpandableDescriptionV2/ExpandableDescriptionV2.styles';
import { Typography } from '@mui/material';

const ExpandableDescriptionV2 = (props) => {
  const { description, className } = props;

  return (
    <StyledBox className={className}>
      <Typography
        component="div"
        className="EDText"
        variant="body2"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </StyledBox>
  );
};

export { ExpandableDescriptionV2 };
